<app-spinner [isLoading]="isLoading$ | async">
  <div class="page">
    <div class="page__inner">
      <div class="general">
        <h2 class="general__title">{{ 'label.CvBoxPageTitle' | translate }}</h2>
        <div class="general__search">
          <div class="general__search-input">
            <button (click)="onSearchClick(searchTerm)" class="general__search-icon-btn">
              <svg-icon src="/assets/icons/search-outline.svg" [svgClass]="'ico-search'"></svg-icon>
            </button>
            <input
              [(ngModel)]="searchTerm"
              type="text"
              class="general__search-text"
              placeholder="({{ 'label.SearchCompany' | translate }})"
            />
          </div>
          <button (click)="onSearchClick(searchTerm)" class="general__search-btn">
            {{ 'label.Search' | translate }}
          </button>
        </div>
      </div>

      <div class="description">
        <div
          [innerHTML]="
            'text.CvBoxDescriptionTitle'
              | translate: { website: ((website$ | async)?.displayName | uppercase) }
              | safeHtml
          "
        ></div>
        <div [innerHTML]="'text.CvBoxDescriptionAdvantages' | translate | safeHtml"></div>

        <div class="description__follow">{{ 'text.CvBoxDescriptionFollowPart1' | translate }}</div>
        <ol class="description__list">
          <li>
            <span class="description__link">
              <a [routerLink]="['/jobseeker/register']">
                <span>{{ 'text.CvBoxDescriptionFollowLinkRegister' | translate }} </span>
              </a>
            </span>
            <span>{{
              'text.CvBoxDescriptionFollowPart2'
                | translate: { website: (website$ | async)?.displayName | uppercase }
            }}</span>
          </li>
          <li>
            <span class="description__link">
              <a [routerLink]="['/jobseeker/sign-in']">
                <span>{{ 'text.CvBoxDescriptionFollowLinkSignin' | translate }} </span>
              </a>
            </span>
            <span
              [innerHTML]="
                'text.CvBoxDescriptionFollowPart3'
                  | translate: { website: ((website$ | async)?.displayName | uppercase) }
                  | safeHtml
              "
            ></span>
          </li>
        </ol>
      </div>

      @if ((vipCvBoxes$ | async)?.length) {
      <section class="section section--vip">
        <div class="section__title">{{ 'label.Vip' | translate }}</div>
        <div class="section__card">
          <div class="section__list">
            @for (cvBox of vipCvBoxes$ | async; track cvBox.customerId) {
            <app-cv-box-item [cvBox]="cvBox" class="item" [userType]="userType$ | async"></app-cv-box-item>
            }
          </div>
        </div>
      </section>
      }

      <!--Vip banner-->
      <div class="banner">
        <app-banner [banner]="vipBanner$ | async" [pageId]="pageId.CvBoxPage"></app-banner>
      </div>

      @if ((premiumCvBoxes$ | async)?.length) {
      <section class="section section--exclusive">
        <div class="section__title">{{ 'label.Premium' | translate }}</div>
        <div class="section__card">
          <div class="section__list">
            @for (cvBox of premiumCvBoxes$ | async; track cvBox.customerId) {
            <app-cv-box-item [cvBox]="cvBox" class="item" [userType]="userType$ | async"></app-cv-box-item>
            }
          </div>
        </div>
      </section>
      }

      <!--Premium banner-->
      <div class="banner">
        <app-banner [banner]="premiumBanner$ | async" [pageId]="pageId.CvBoxPage"></app-banner>
      </div>

      @if ((standardCvBoxes$ | async)?.length) {
      <section class="section section--regular">
        <div class="section__title">{{ 'label.Standard' | translate }}</div>
        <div class="section__card">
          <div class="section__list">
            @for (cvBox of standardCvBoxes$ | async; track cvBox.customerId) {
            <app-cv-box-item [cvBox]="cvBox" class="item" [userType]="userType$ | async"></app-cv-box-item>
            }
          </div>
        </div>
      </section>
      }

      <!--Regular banner-->
      <div class="banner">
        <app-banner [banner]="regularBanner$ | async" [pageId]="pageId.CvBoxPage"></app-banner>
      </div>
    </div>
  </div>
</app-spinner>
